import { render, staticRenderFns } from "./UploadFileForm.vue?vue&type=template&id=63e103a5&scoped=true&"
import script from "./UploadFileForm.vue?vue&type=script&lang=ts&"
export * from "./UploadFileForm.vue?vue&type=script&lang=ts&"
import style0 from "./UploadFileForm.vue?vue&type=style&index=0&id=63e103a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e103a5",
  null
  
)

export default component.exports